import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ConnectionService } from './connection.service';
import { InventoryCatRenameDialogComponent } from '../dialogs/inventory-cat-rename-dialog/inventory-cat-rename.dialog';
import { InventoryCategory } from '@contracts/interfaces/inventory-category';
import { InventoryItemTemplateDialogComponent } from '../dialogs/inventory-item-template-dialog/inventory-item-template.dialog';
import { InventoryCategoryNewDialogComponent } from '../dialogs/inventory-category-new-dialog/inventory-category-new.dialog';
import { InventoryCategoryFactory } from '../factories/inventory-category.factory';
import { map } from 'rxjs';
import { InventoryItemDialogComponent } from '../dialogs/inventory-item-dialog/inventory-item.dialog';
import { inventoryCategoriesDialogComponent } from '../dialogs/inventory-categories-dialog/inventory-categories.dialog';


@Injectable({
  providedIn: 'root'
})
export class InventoryCategoryService {

    constructor(private http: HttpClient,
        private connectionService: ConnectionService,
        private dialog: MatDialog) {}

  private get sessionOptions() {
    return { headers: { authtoken: this.connectionService.activeConnection?.token || '' } };
  }
    

  find(query: any) {
    return this.http.post(this.connectionService.address + "/inventory-category-service/find", { query }, this.sessionOptions).pipe(
      map((categories: InventoryCategory[]) => {
        for (let i=0; i < categories.length;i++) {
          categories[i] = InventoryCategoryFactory.validate(categories[i]);
        }

        return categories;
      })
    );
  }

  get(categoryID: number) {
      return this.http.post(this.connectionService.address + "/inventory-category-service/get", { categoryID }, this.sessionOptions).pipe(
        map((r: InventoryCategory) => {
          if (r != null) {
            return InventoryCategoryFactory.validate(r);
          }
        })
      );
  }

  updateOne() {

  }

  archive(categoryID: number) {
    return this.http.post(this.connectionService.address + "/inventory-category-service/archive", { categoryID });
  }

  renameOne() {

  }

  create(category: InventoryCategory) {
    return this.http.post(this.connectionService.address + "/inventory-category-service/create", { category });
  }

  updateCategory(category: InventoryCategory) {
    return this.http.post(this.connectionService.address + "/inventory-category-service/update", { category });
  }

  newCategoryDialog(callback: any) {
    let dialog = this.dialog.open(InventoryCategoryNewDialogComponent, {
      width: '600px',
      autoFocus: false,
      data: {}
    });

    dialog.afterClosed().subscribe((r: any) => {
      callback(r);
    })    
  }

  renameCategory(category: InventoryCategory, callback: any) {

    let dialog = this.dialog.open(InventoryCatRenameDialogComponent, {
      width: '600px',
      autoFocus: false,
      data: { 
        category
      }
    });

    dialog.afterClosed().subscribe((r: any) => {
      callback(r);
    })
  }


  openInventoryCategoriesDialog() {
    let dialog = this.dialog.open(inventoryCategoriesDialogComponent, {
      width: '1200px',
      autoFocus: false,
      data: {}
    })
  }

  openInventoryItemTemplateDialog(categoryID: number, callback: any) {
    let dialog = this.dialog.open(InventoryItemTemplateDialogComponent, {
      width: "100%",
      maxWidth: "1200px",
      position: {
        top: '20px'
      },
      autoFocus: false,
      data: {
        categoryID
      }
    });

    dialog.afterClosed().subscribe((r: any) => {
      callback(r);
    })
  }

  makeURLSafeName(nicename: string) {
    return nicename.replace(/([^a-z0-9]+)/gi, "-").toLowerCase();
  }
}
